import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SIGNUP = '/register?type=adult_worker';

const FEATURES_LIST = [
  ['Licznik urlopu', 'Widzisz, ile dni urlopu Ci przysługuje, ile już wykorzystałeś i ile zostało.'],
  ['Wnioski z telefonu', 'Wybierasz dni w kalendarzu i wysyłasz wniosek do pracodawcy. Od razu widzisz, czy został zaakceptowany.'],
  ['Historia zatrudnienia', 'Zapisujesz swoje kolejne miejsca pracy w jednym miejscu, żeby mieć je pod ręką.'],
];

const STEPS = [
  ['Załóż konto pracownika', 'To nic nie kosztuje i zajmuje kilka minut.'],
  ['Przyjmij zaproszenie', 'Twój pracodawca zaprasza Cię do swojej firmy w SIGMIE. Zaproszenie akceptujesz jednym kliknięciem.'],
  ['Składaj wnioski', 'Od teraz o urlop prosisz w aplikacji, a odpowiedź dostajesz w tym samym miejscu.'],
];

function ForEmployees() {
  return (
    <>
      <Helmet>
        <title>Dla pracowników – SIGMA | Urlop i wnioski w telefonie</title>
        <meta name="description" content="Sprawdzaj, ile masz urlopu, i składaj wnioski do pracodawcy z telefonu. Dla pracownika SIGMA jest bezpłatna." />
      </Helmet>

      <section className="pub-section">
        <div className="pub-wrap">
          <div className="pub-kicker">Dla pracowników</div>
          <h1 className="pub-h1">Wiesz, ile masz urlopu, i prosisz o niego z&nbsp;telefonu.</h1>
          <p className="pub-lead">
            Bez pytania szefa na korytarzu i bez liczenia dni na kartce. Dla pracownika SIGMA jest całkowicie za darmo.
          </p>
          <div className="pub-actions">
            <Link to={SIGNUP} className="pub-btn">Załóż konto pracownika</Link>
            <Link to="/" className="pub-link">Jesteś pracodawcą? Zobacz ofertę dla firm</Link>
          </div>
        </div>
      </section>

      <section className="pub-section pub-section--alt">
        <div className="pub-wrap">
          <h2 className="pub-h2">Co dostajesz</h2>
          <div className="pub-grid-3" style={{ marginTop: 28 }}>
            {FEATURES_LIST.map(([title, text], i) => (
              <div key={title}>
                <div className="pub-num">{String(i + 1).padStart(2, '0')}</div>
                <h3 className="pub-h3">{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pub-section">
        <div className="pub-wrap">
          <h2 className="pub-h2">Jak zacząć</h2>
          <div className="pub-grid-3" style={{ marginTop: 28 }}>
            {STEPS.map(([title, text], i) => (
              <div key={title}>
                <div className="pub-num">Krok {i + 1}</div>
                <h3 className="pub-h3">{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
          <p className="pub-muted" style={{ marginTop: 28, maxWidth: '62ch' }}>
            Twojego pracodawcy nie ma jeszcze w SIGMIE? Pokaż mu tę stronę. Dla firmy pierwszy pracownik też jest za darmo.
          </p>
        </div>
      </section>

      <section className="pub-section" style={{ background: 'var(--pub-navy)', color: '#fff', borderBottom: 'none' }}>
        <div className="pub-wrap">
          <h2 className="pub-h2" style={{ color: '#fff' }}>Konto pracownika jest bezpłatne.</h2>
          <p style={{ color: '#cbd5e1', marginBottom: 28 }}>Załóż je teraz i poczekaj na zaproszenie od pracodawcy.</p>
          <Link to={SIGNUP} className="pub-btn pub-btn--light">Załóż konto pracownika</Link>
        </div>
      </section>
    </>
  );
}

export default ForEmployees;
